export const FILTER_NAME = 'condition'
